
import { Component, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { SystemModule } from "@/store/modules/index";
import { formatPhoneNumber } from "@/utils";

const systemModule = getModule(SystemModule);

interface DefaultField {
  key: string;
  label: string;
}

@Component
export default class Facilities extends Vue {
  loading: boolean = false;
  
  allItems: Array<any> = [];
  filteredItems: Array<any> = [];
  paginatedItems: Array<any> = [];

  sortKey: string = "";
  includeInactive: boolean = false;
  searchName: string = "";
  sortDirection: number = 1;

  pageNumber: number = 1;
  totalItems: number = 0;
  pageSize: number = 15;

  fields: Array<DefaultField> = [
    {
      key: "companyName",
      label: "Company Name"
    },
    {
      key: "name",
      label: "CDS Name"
    },
    {
      key: "serviceType",
      label: "Service Type"
    },
    {
      key: "isActive",
      label: "Active?"
    },
    {
      key: "phone",
      label: "Phone Number"
    },
    {
      key: "tollFreePhone",
      label: "Toll-Free"
    },
    {
      key: "location",
      label: "Location"
    },
    {
      key: "facilityCode",
      label: "Facility Code"
    },

    {
      key: "actions",
      label: ""
    }
  ];

  async created() {
    await this.getFacilities();
  }

  @Watch("allItems")
  async onAllItemsLoaded() {
    await this.filterFacilities();
  }

  @Watch("includeInactive")
  async includeInactiveChanged() {
    await this.filterFacilities();
  }

  formattedPhoneNumber(phoneNumber) {
    return phoneNumber ? formatPhoneNumber(phoneNumber) : '';
  }
  
  @Watch("searchName")
  filterFacilities() {
    let regex = new RegExp( this.searchName, "i");

    this.filteredItems =  this.allItems
      .filter( item => !this.searchName || 
        regex.test( item.facilityCode ) || 
        regex.test( item.companyName ) || 
        regex.test( item.internalName ) || 
        regex.test( item.phone ) || 
        regex.test( item.tollFreePhone ) ||
        regex.test( item.city ) )
      .filter(item => item.isActive || this.includeInactive)

    this.pageNumber = 1;
    this.totalItems = this.filteredItems.length;

    this.paginateFacilities()
  }

  @Watch("pageNumber")
  paginateFacilities() {
    let filteredItems = 
      (this.filteredItems ?? [])
        .slice( (this.pageNumber -1) * this.pageSize, (this.pageNumber -1) * this.pageSize + this.pageSize -1 )
        .map(item => {return {...item}})
    
    if( !!this.searchName ) {
      let regex = new RegExp( this.searchName, "i");

      filteredItems.forEach(item => {
        if(item.facilityCode) item.facilityCode = item.facilityCode.replace(regex, `<b>$&</b>`)
        if(item.companyName) item.companyName = item.companyName.replace(regex, `<b>$&</b>`)
        if(item.name) item.name = item.name.replace(regex, `<b>$&</b>`)
        if(item.phone) item.phone = item.phone.replace(regex, `<b>$&</b>`)
        if(item.tollFreePhone) item.tollFreePhone = item.tollFreePhone.replace(regex, `<b>$&</b>`)
      });
    }

    this.paginatedItems  = filteredItems;
  }

  rowSelected(item, index, event) {
    let url = `/admin/facility/${item.facilityCode}`
    this.$router.push(url);
  }

  async getFacilities() {
    this.loading = true;
    const response: any = await systemModule.getFacilities("N");

    response.items.forEach((e) => {
      e.phone = formatPhoneNumber(e.phone)
      e.tollFreePhone = formatPhoneNumber(e.tollFreePhone)
      e.customerServicePhone = formatPhoneNumber(e.customerServicePhone)
      e.fax = formatPhoneNumber(e.fax)
      e.key = e.facilityCode;
    });

    this.allItems = response.items;
    this.loading = false; 



    this.setSort("companyName");
  }

  setSort(fieldName: string) {
    if(this.sortKey === fieldName)
      this.sortDirection *= -1;

    this.sortKey = fieldName;
    this.allItems  = (this.allItems ?? []).sort( (a, b) => {
      
      let sortResults = 1;  
      if(a[this.sortKey] == b[this.sortKey])
        sortResults = 0;

      if(a[this.sortKey] < b[this.sortKey])
        sortResults = -1;

      return sortResults * this.sortDirection;
    });

    this.paginateFacilities();
  }

  getServiceTypeString(value) {
    if(value == "DO")
      return "Delivery";

    if(value == "WO")
      return "Warehouse";
    
    if(value == "BOTH")
      return "Warehouse/Delivery";   

    return "N/A";
  }

  getLocationString(row) {
    let regex = new RegExp( this.searchName, "i");
    let city = (row.item.city ?? "").replace(regex, `<b>$&</b>`)
    return `${city}, ${row.item?.state ?? ""}`;
  }
}
